export const SUBSCRIPTION_COMPONENT_TRANSLATIONS = {
  back: {
    "pt-BR": "Voltar",
    en: "Back",
    es: "Volver",
    de: "Zurück",
  },
  cancel: {
    "pt-BR": "Cancelar",
    en: "Cancel",
    es: "Cancelar",
    de: "Stornieren",
  },
  continue: {
    "pt-BR": "Continuar",
    en: "Continue",
    es: "Continuar",
    de: "Weitermachen",
  },
  close: {
    "pt-BR": "Fechar",
    en: "Close",
    es: "Cerrar",
    de: "Schließen",
  },
  saving: {
    "pt-BR": "Salvando…",
    en: "Saving…",
    es: "Guardando…",
    de: "Sparen…",
  },
  paymentMethodChangeUnavailable: {
    "pt-BR": "Alteração de forma de pagamento indisponível no momento.",
    en: "Payment method change is unavailable right now.",
    es: "El cambio de forma de pago no está disponible en este momento.",
    de: "Die Änderung der Zahlungsmethode ist derzeit nicht verfügbar.",
  },
  pixAuthorizationRefused: {
    "pt-BR": "Autorização Pix recusada. Tente novamente ou escolha outra forma de pagamento.",
    en: "Pix authorization was declined. Try again or choose another payment method.",
    es: "Autorización Pix rechazada. Inténtalo de nuevo o elige otra forma de pago.",
    de: "Die Pix-Autorisierung wurde abgelehnt. Versuchen Sie es erneut oder wählen Sie eine andere Zahlungsmethode.",
  },
  paymentConfirmed: {
    "pt-BR": "Pagamento confirmado!",
    en: "Payment confirmed!",
    es: "¡Pago confirmado!",
    de: "Zahlung bestätigt!",
  },
  paymentMethodChanged: {
    "pt-BR": "Forma de pagamento alterada com sucesso!",
    en: "Payment method changed successfully!",
    es: "¡Forma de pago cambiada con éxito!",
    de: "Zahlungsart erfolgreich geändert!",
  },
  subscriptionActivated: {
    "pt-BR": "Assinatura ativada com sucesso!",
    en: "Subscription activated successfully!",
    es: "¡Suscripción activada con éxito!",
    de: "Abonnement erfolgreich aktiviert!",
  },
  accountRepairedForPlan: {
    "pt-BR": "Conta reparada para o plano {planName}.",
    en: "Account repaired for the {planName} plan.",
    es: "Cuenta reparada para el plan {planName}.",
    de: "Konto für den {planName}-Plan repariert.",
  },
  planUpdatedWithProration: {
    "pt-BR": "Plano atualizado. Cobrança proporcional: {amount}.",
    en: "Plan updated. Prorated charge: {amount}.",
    es: "Plan actualizado. Cobro proporcional: {amount}.",
    de: "Plan aktualisiert. Anteilige Gebühr: {amount}.",
  },
  planUpdatedSuccess: {
    "pt-BR": "Plano atualizado com sucesso!",
    en: "Plan updated successfully!",
    es: "¡Plan actualizado con éxito!",
    de: "Plan erfolgreich aktualisiert!",
  },
  subscriptionReactivated: {
    "pt-BR": "Sua assinatura foi reativada.",
    en: "Your subscription was reactivated.",
    es: "Tu suscripción fue reactivada.",
    de: "Ihr Abonnement wurde reaktiviert.",
  },
  completePaymentToContinue: {
    "pt-BR": "Conclua o pagamento do plano escolhido para continuar.",
    en: "Complete payment for your chosen plan to continue.",
    es: "Completa el pago del plan elegido para continuar.",
    de: "Schließen Sie die Zahlung für den von Ihnen gewählten Plan ab, um fortfahren zu können.",
  },
  modalTitleSuccess: {
    "pt-BR": "Assinatura confirmada",
    en: "Subscription confirmed",
    es: "Suscripción confirmada",
    de: "Abonnement bestätigt",
  },
  modalTitleManage: {
    "pt-BR": "Gerenciar assinatura",
    en: "Manage subscription",
    es: "Gestionar suscripción",
    de: "Abonnement verwalten",
  },
  modalTitleSubscribe: {
    "pt-BR": "Assinar plano",
    en: "Subscribe to a plan",
    es: "Suscribirse a un plan",
    de: "Abonnieren Sie einen Plan",
  },
  loadingSubscription: {
    "pt-BR": "Carregando assinatura…",
    en: "Loading subscription…",
    es: "Cargando suscripción…",
    de: "Abonnement wird geladen…",
  },
  currentPlanBadge: {
    "pt-BR": "Plano atual",
    en: "Current plan",
    es: "Plan actual",
    de: "Aktueller Plan",
  },
  changePaymentMethodLabelPixOrCard: {
    "pt-BR": "Trocar forma de pagamento (Pix ou cartão)",
    en: "Change payment method (Pix or card)",
    es: "Cambiar forma de pago (Pix o tarjeta)",
    de: "Zahlungsmethode ändern (Pix oder Karte)",
  },
  changePaymentMethodLabelCardOnly: {
    "pt-BR": "Trocar forma de pagamento (cartão)",
    en: "Change payment method (card)",
    es: "Cambiar forma de pago (tarjeta)",
    de: "Zahlungsart (Karte) ändern",
  },
  planChangeFromPrefix: {
    "pt-BR": "Alterar de",
    en: "Change from",
    es: "Cambiar de",
    de: "Wechsel von",
  },
  planChangeToConnector: {
    "pt-BR": "para",
    en: "to",
    es: "a",
    de: "Zu",
  },
  planChangeDowngradeImmediate: {
    "pt-BR":
      "A alteração entra em vigor imediatamente após a confirmação. Seu plano e recursos serão ajustados na hora.",
    en: "The change takes effect immediately after confirmation. Your plan and resources will be adjusted right away.",
    es: "El cambio entra en vigor inmediatamente después de la confirmación. Tu plan y recursos se ajustarán al instante.",
    de: "Die Änderung wird sofort nach Bestätigung wirksam. Ihr Plan und Ihre Ressourcen werden umgehend angepasst.",
  },
  planChangeClinicRemains: {
    "pt-BR":
      "A clínica e a Gestão Clínica permanecem ativas. Pacientes e membros da equipe continuam vinculados a esta organização. Os limites de assentos e recursos passam a ser os do plano escolhido.",
    en: "Your clinic and Clinical Management stay active. Patients and team members remain linked to this organization. Seat and feature limits become those of the selected plan.",
    es: "La clínica y la Gestión Clínica siguen activas. Los pacientes y los miembros del equipo permanecen vinculados a esta organización. Los límites de asientos y recursos pasan a ser los del plan elegido.",
    de: "Ihre Klinik und die klinische Verwaltung bleiben aktiv. Patienten und Teammitglieder bleiben mit dieser Organisation verknüpft. Sitz- und Funktionslimits entsprechen dem gewählten Plan.",
  },
  /** Paying Multi→lower: proportional credit + next-due list price (BR-CCF-15, AC-CCF-06). */
  planChangeDowngradeCredit: {
    "pt-BR":
      "O valor proporcional não utilizado do plano Multi vira crédito para faturas futuras (não é reembolso em dinheiro). O preço de lista do novo plano passa a valer a partir do próximo vencimento.",
    en: "Unused Multi plan value becomes credit toward future invoices (not a cash refund). The new plan's list price applies from the next due date.",
    es: "El valor proporcional no utilizado del plan Multi se convierte en crédito para facturas futuras (no es un reembolso en efectivo). El precio de lista del nuevo plan aplica a partir del próximo vencimiento.",
    de: "Der anteilig ungenutzte Multi-Planwert wird als Guthaben für künftige Rechnungen gutgeschrieben (keine Barerstattung). Der Listenpreis des neuen Plans gilt ab dem nächsten Fälligkeitsdatum.",
  },
  planChangeUpgradeImmediate: {
    "pt-BR":
      "A alteração entra em vigor imediatamente após a confirmação, com cobrança proporcional quando aplicável.",
    en: "The change takes effect immediately after confirmation, with prorated billing when applicable.",
    es: "El cambio entra en vigor inmediatamente después de la confirmación, con cobro proporcional cuando aplique.",
    de: "Die Änderung wird sofort nach Bestätigung wirksam, ggf. mit anteiliger Abrechnung.",
  },
  planChangeReactivatesRenewal: {
    "pt-BR": "A alteração também reativará a renovação da sua assinatura.",
    en: "The change will also reactivate your subscription renewal.",
    es: "El cambio también reactivará la renovación de tu suscripción.",
    de: "Durch die Änderung wird auch Ihre Abonnementverlängerung reaktiviert.",
  },
  confirmPlanChange: {
    "pt-BR": "Confirmar alteração",
    en: "Confirm change",
    es: "Confirmar cambio",
    de: "Änderung bestätigen",
  },
  trialUpgradeIntro: {
    "pt-BR":
      "Para mudar de {currentPlan} para {targetPlan} ({price}{period}), é necessário concluir o pagamento agora {paymentMethods}.",
    en: "To change from {currentPlan} to {targetPlan} ({price}{period}), you must complete payment now {paymentMethods}.",
    es: "Para cambiar de {currentPlan} a {targetPlan} ({price}{period}), debes completar el pago ahora {paymentMethods}.",
    de: "Um von {currentPlan} zu {targetPlan} ({price}{period}) zu wechseln, müssen Sie die Zahlung jetzt abschließen {paymentMethods}.",
  },
  trialUpgradePaymentPixOrCard: {
    "pt-BR": "com Pix ou cartão",
    en: "with Pix or card",
    es: "con Pix o tarjeta",
    de: "mit Pix oder Karte",
  },
  trialUpgradePaymentCardOnly: {
    "pt-BR": "com cartão",
    en: "with card",
    es: "con tarjeta",
    de: "mit Karte",
  },
  trialUpgradeStayOnBasic: {
    "pt-BR":
      "Se você cancelar ou não finalizar o pagamento, permanecerá no plano básico com os recursos atuais.",
    en: "If you cancel or do not complete payment, you will remain on the basic plan with your current resources.",
    es: "Si cancelas o no completas el pago, permanecerás en el plan básico con los recursos actuales.",
    de: "Wenn Sie kündigen oder die Zahlung nicht abschließen, bleiben Sie mit Ihren aktuellen Ressourcen im Basisplan.",
  },
  agreeAndPay: {
    "pt-BR": "Concordar e pagar",
    en: "Agree and pay",
    es: "Aceptar y pagar",
    de: "Zustimmen und bezahlen",
  },
  freeBasicTrialDays: {
    "pt-BR": "Você terá 15 dias de experimentação no plano Básico com os recursos completos do plano.",
    en: "You will get a 15-day trial on the Basic plan with full plan features.",
    es: "Tendrás 15 días de prueba en el plan Básico con todas las funciones del plan.",
    de: "Sie erhalten eine 15-tägige Testversion des Basic-Plans mit allen Planfunktionen.",
  },
  freeBasicTrialCardCharge: {
    "pt-BR":
      "Vamos cadastrar seu cartão agora. A primeira cobrança será feita somente após o término do período de testes.",
    en: "We will register your card now. The first charge will only happen after the trial period ends.",
    es: "Registraremos tu tarjeta ahora. El primer cobro se realizará solo después del período de prueba.",
    de: "Wir registrieren Ihre Karte jetzt. Die erste Aufladung erfolgt erst nach Ablauf des Testzeitraums.",
  },
  freeBasicTrialCancelStayFree: {
    "pt-BR": "Se você cancelar antes de concluir, permanecerá no plano Gratuito.",
    en: "If you cancel before completing, you will remain on the Free plan.",
    es: "Si cancelas antes de completar, permanecerás en el plan Gratuito.",
    de: "Wenn Sie vor Abschluss kündigen, bleiben Sie beim kostenlosen Plan.",
  },
  agreeAndContinue: {
    "pt-BR": "Concordar e continuar",
    en: "Agree and continue",
    es: "Aceptar y continuar",
    de: "Zustimmen und fortfahren",
  },
  clinicSetupIntro: {
    "pt-BR": "Informe os dados da organização antes de confirmar a alteração para o plano Clínica.",
    en: "Enter organization details before confirming the change to the Clinic plan.",
    es: "Indica los datos de la organización antes de confirmar el cambio al plan Clínica.",
    de: "Geben Sie die Organisationsdetails ein, bevor Sie die Änderung des Klinikplans bestätigen.",
  },
  secretaryMigrationIntro: {
    "pt-BR":
      "Ao migrar para o Multi, escolha uma secretária solo para manter ativa na organização ou pule para desativar todas.",
    en: "When migrating to Multi, choose one solo secretary to keep active in the organization or skip to deactivate all.",
    es: "Al migrar a Multi, elige una secretaria individual para mantener activa en la organización o omite para desactivar todas.",
    de: "Wählen Sie bei der Migration zu Multi eine Solo-Sekretärin aus, die in der Organisation aktiv bleiben soll, oder überspringen Sie die Funktion, um alle zu deaktivieren.",
  },
  secretaryMigrationSkip: {
    "pt-BR": "Pular (desativar secretárias solo)",
    en: "Skip (deactivate solo secretaries)",
    es: "Omitir (desactivar secretarias individuales)",
    de: "Überspringen (Solo-Sekretärinnen deaktivieren)",
  },
  methodStepPlanLabel: {
    "pt-BR": "Plano:",
    en: "Plan:",
    es: "Plan:",
    de: "Planen:",
  },
  methodStepPaymentMethodProration: {
    "pt-BR":
      "A troca de forma de pagamento gera ajuste proporcional pelos dias já utilizados e reinicia o ciclo mensal com valor integral.",
    en: "Changing payment method applies prorated adjustment for days already used and restarts the monthly cycle at full price.",
    es: "El cambio de forma de pago genera ajuste proporcional por los días ya utilizados y reinicia el ciclo mensual con valor íntegro.",
    de: "Durch die Änderung der Zahlungsmethode wird eine anteilige Anpassung für bereits genutzte Tage vorgenommen und der monatliche Zyklus zum vollen Preis neu gestartet.",
  },
  methodStepTrialPayment: {
    "pt-BR":
      "Conclua o pagamento para ativar o plano {planName}. Se não finalizar, você permanece no plano básico.",
    en: "Complete payment to activate the {planName} plan. If you do not finish, you remain on the basic plan.",
    es: "Completa el pago para activar el plan {planName}. Si no finalizas, permaneces en el plan básico.",
    de: "Schließen Sie die Zahlung ab, um den {planName}-Plan zu aktivieren. Wenn Sie nicht fertig sind, bleiben Sie beim Basisplan.",
  },
  pixAutomaticTitle: {
    "pt-BR": "Pix Automático",
    en: "Automatic Pix",
    es: "Pix automático",
    de: "Automatisches Pix",
  },
  pixAutomaticDescription: {
    "pt-BR": "Autorize débitos mensais com Pix.",
    en: "Authorize monthly debits with Pix.",
    es: "Autoriza débitos mensuales con Pix.",
    de: "Autorisieren Sie monatliche Abbuchungen mit Pix.",
  },
  pixCardOnlyUpgrade: {
    "pt-BR": "Disponível apenas com cartão de crédito neste upgrade.",
    en: "Available with credit card only for this upgrade.",
    es: "Disponible solo con tarjeta de crédito en esta mejora.",
    de: "Für dieses Upgrade nur mit Kreditkarte verfügbar.",
  },
  pixUnavailableUntilAsaas: {
    "pt-BR": "Indisponível.",
    en: "Unavailable.",
    es: "No disponible.",
    de: "Nicht verfügbar.",
  },
  creditCardTitle: {
    "pt-BR": "Cartão de crédito",
    en: "Credit card",
    es: "Tarjeta de crédito",
    de: "Kreditkarte",
  },
  creditCardDescription: {
    "pt-BR": "Cobrança recorrente mensal.",
    en: "Recurring monthly billing.",
    es: "Cobro recurrente mensual.",
    de: "Wiederkehrende monatliche Abrechnung.",
  },
  pixScanQrCode: {
    "pt-BR": "Escaneie o QR Code ou copie o código Pix abaixo.",
    en: "Scan the QR code or copy the Pix code below.",
    es: "Escanea el código QR o copia el código Pix abajo.",
    de: "Scannen Sie den QR-Code oder kopieren Sie den Pix-Code unten.",
  },
  pixCopyCode: {
    "pt-BR": "Copiar código Pix",
    en: "Copy Pix code",
    es: "Copiar código Pix",
    de: "Pix-Code kopieren",
  },
  pixCodeCopied: {
    "pt-BR": "Código Pix copiado.",
    en: "Pix code copied.",
    es: "Código Pix copiado.",
    de: "Pix-Code kopiert.",
  },
  pixDevNotAutoConfirmed: {
    "pt-BR": "Ambiente de desenvolvimento: o pagamento não é confirmado automaticamente.",
    en: "Development environment: payment is not confirmed automatically.",
    es: "Entorno de desarrollo: el pago no se confirma automáticamente.",
    de: "Entwicklungsumgebung: Die Zahlung wird nicht automatisch bestätigt.",
  },
  pixSimulatePayment: {
    "pt-BR": "Simular pagamento (desenvolvimento)",
    en: "Simulate payment (development)",
    es: "Simular pago (desarrollo)",
    de: "Zahlung simulieren (Entwicklung)",
  },
  pixPaymentSimulated: {
    "pt-BR": "Pagamento simulado com sucesso!",
    en: "Payment simulated successfully!",
    es: "¡Pago simulado con éxito!",
    de: "Zahlung erfolgreich simuliert!",
  },
  pixAwaitingConfirmation: {
    "pt-BR": "Aguardando confirmação do pagamento…",
    en: "Waiting for payment confirmation…",
    es: "Esperando confirmación del pago…",
    de: "Warten auf Zahlungsbestätigung…",
  },
  cardNumberLabel: {
    "pt-BR": "Número do cartão",
    en: "Card number",
    es: "Número de tarjeta",
    de: "Kartennummer",
  },
  cardCvvPlaceholder: {
    "pt-BR": "CVV",
    en: "CVV",
    es: "CVV",
    de: "CVV",
  },
  cardHolderNamePlaceholder: {
    "pt-BR": "Nome no cartão",
    en: "Name on card",
    es: "Nombre en la tarjeta",
    de: "Name auf der Karte",
  },
  cardHolderCpfPlaceholder: {
    "pt-BR": "CPF do titular",
    en: "Cardholder CPF",
    es: "CPF del titular",
    de: "Karteninhaber CPF",
  },
  confirmPayment: {
    "pt-BR": "Confirmar pagamento",
    en: "Confirm payment",
    es: "Confirmar pago",
    de: "Bestätigen Sie die Zahlung",
  },
  successActiveMessage: {
    "pt-BR": "Sua assinatura {planName} está ativa. Você já pode usar todos os recursos do plano.",
    en: "Your {planName} subscription is active. You can now use all plan features.",
    es: "Tu suscripción {planName} está activa. Ya puedes usar todas las funciones del plan.",
    de: "Ihr {planName}-Abonnement ist aktiv. Sie können nun alle Planfunktionen nutzen.",
  },
  simulatePostTrialCharge: {
    "pt-BR": "Simular cobrança pós-trial (dev)",
    en: "Simulate post-trial charge (dev)",
    es: "Simular cobro post-prueba (dev)",
    de: "Post-Test-Gebühr simulieren (dev)",
  },
  postTrialChargeSimulated: {
    "pt-BR": "Cobrança pós-trial simulada.",
    en: "Post-trial charge simulated.",
    es: "Cobro post-prueba simulado.",
    de: "Anklage nach dem Prozess simuliert.",
  },
  logoutAccount: {
    "pt-BR": "Sair da conta",
    en: "Sign out",
    es: "Cerrar sesión",
    de: "Abmelden",
  },
  goBack: {
    "pt-BR": "Voltar",
    en: "Go back",
    es: "Volver",
    de: "Geh zurück",
  },
  billingProfileIncompleteTitle: {
    "pt-BR": "Perfil incompleto para pagamento",
    en: "Incomplete profile for payment",
    es: "Perfil incompleto para pago",
    de: "Unvollständiges Profil zur Zahlung",
  },
  billingProfileCompletePrompt: {
    "pt-BR": "Para concluir o pagamento por cartão, complete no perfil:",
    en: "To complete card payment, complete in your profile:",
    es: "Para completar el pago con tarjeta, completa en el perfil:",
    de: "Um die Kartenzahlung abzuschließen, geben Sie in Ihrem Profil Folgendes ein:",
  },
  billingProfileRedirectCountdown: {
    "pt-BR":
      "Você será redirecionado em {seconds} segundos para o perfil. Após atualizar, volte em Assinatura para tentar novamente.",
    en: "You will be redirected in {seconds} seconds to your profile. After updating, return to Subscription to try again.",
    es: "Serás redirigido en {seconds} segundos al perfil. Después de actualizar, vuelve a Suscripción para intentar de nuevo.",
    de: "Sie werden in {seconds} Sekunden zu Ihrem Profil weitergeleitet. Kehren Sie nach der Aktualisierung zum Abonnement zurück, um es erneut zu versuchen.",
  },
  goNow: {
    "pt-BR": "Ir agora",
    en: "Go now",
    es: "Ir ahora",
    de: "Geh jetzt",
  },
  cancelSubscriptionTitle: {
    "pt-BR": "Cancelar assinatura",
    en: "Cancel subscription",
    es: "Cancelar suscripción",
    de: "Abo kündigen",
  },
  cancelSubscriptionIntro: {
    "pt-BR": "Você está no plano {planName}. Ao confirmar, a renovação será cancelada, mas você mantém o acesso ao plano atual até {endDate}.",
    en: "You are on the {planName} plan. After confirming, renewal will be cancelled, but you keep access to the current plan until {endDate}.",
    es: "Estás en el plan {planName}. Al confirmar, la renovación se cancelará, pero mantienes acceso al plan actual hasta {endDate}.",
    de: "Sie nutzen den {planName}-Plan. Nach der Bestätigung wird die Verlängerung abgebrochen, Sie behalten jedoch bis {endDate} Zugriff auf den aktuellen Plan.",
  },
  cancelSubscriptionEndOfPaidPeriod: {
    "pt-BR": "o fim do período pago",
    en: "the end of the paid period",
    es: "el fin del período pagado",
    de: "das Ende des bezahlten Zeitraums",
  },
  cancelSubscriptionBillingOnlyAfter: {
    "pt-BR":
      "Sua assinatura será cancelada ao fim do período pago. Depois dessa data, você poderá fazer login e recontratar um plano em Assinatura, mas o acesso clínico ficará bloqueado até a assinatura.",
    en: "Your subscription will be cancelled at the end of the paid period. After that date, you can sign in and re-subscribe in Subscription, but clinical access stays blocked until you have a subscription.",
    es: "Tu suscripción se cancelará al final del período pagado. Después de esa fecha, podrás iniciar sesión y volver a contratar un plan en Suscripción, pero el acceso clínico quedará bloqueado hasta la suscripción.",
    de: "Ihr Abonnement endet am Ende der bezahlten Periode. Danach können Sie sich anmelden und unter Abonnement erneut buchen, aber der klinische Zugang bleibt bis zur neuen Subscription gesperrt.",
  },
  cancelSubscriptionActivePatients: {
    "pt-BR": "Pacientes ativos no momento: {count}.",
    en: "Active patients right now: {count}.",
    es: "Pacientes activos en este momento: {count}.",
    de: "Derzeit aktive Patienten: {count}.",
  },
  cancelSubscriptionActiveOnly: {
    "pt-BR": "Somente assinaturas ativas podem ser canceladas por aqui.",
    en: "Only active subscriptions can be cancelled here.",
    es: "Solo las suscripciones activas pueden cancelarse aquí.",
    de: "Hier können nur aktive Abonnements gekündigt werden.",
  },
  cancelAckBillingOnly: {
    "pt-BR":
      "Entendo que, ao fim do período pago, o acesso clínico será bloqueado até eu recontratar um plano em Assinatura.",
    en: "I understand that at the end of the paid period, clinical access will be blocked until I re-subscribe in Subscription.",
    es: "Entiendo que, al final del período pagado, el acceso clínico quedará bloqueado hasta que vuelva a contratar un plan en Suscripción.",
    de: "Ich verstehe, dass am Ende der bezahlten Periode der klinische Zugang gesperrt bleibt, bis ich unter Abonnement erneut buche.",
  },
  confirmCancellation: {
    "pt-BR": "Confirmar cancelamento",
    en: "Confirm cancellation",
    es: "Confirmar cancelación",
    de: "Stornierung bestätigen",
  },
  cancelSuccessBillingOnly: {
    "pt-BR":
      "Assinatura cancelada. Ao fim do período pago, o acesso clínico ficará bloqueado até você recontratar em Assinatura.",
    en: "Subscription cancelled. At the end of the paid period, clinical access will be blocked until you re-subscribe in Subscription.",
    es: "Suscripción cancelada. Al final del período pagado, el acceso clínico quedará bloqueado hasta que vuelvas a contratar en Suscripción.",
    de: "Abonnement gekündigt. Am Ende der bezahlten Periode bleibt der klinische Zugang gesperrt, bis Sie unter Abonnement erneut buchen.",
  },
  cancelError: {
    "pt-BR": "Não foi possível cancelar a assinatura.",
    en: "Could not cancel subscription.",
    es: "No fue posible cancelar la suscripción.",
    de: "Das Abonnement konnte nicht gekündigt werden.",
  },
  upgradePlanTitle: {
    "pt-BR": "Faça upgrade do seu plano",
    en: "Upgrade your plan",
    es: "Mejora tu plan",
    de: "Aktualisieren Sie Ihren Plan",
  },
  upgradePlanCurrent: {
    "pt-BR": "Você está no plano {planName} com limite de {limit} pacientes ativos.",
    en: "You are on the {planName} plan with a limit of {limit} active patients.",
    es: "Estás en el plan {planName} con límite de {limit} pacientes activos.",
    de: "Sie nutzen den {planName}-Plan mit einer Begrenzung auf {limit} aktive Patienten.",
  },
  upgradePlanActiveCountSingular: {
    "pt-BR": "Hoje você tem {count} paciente ativo. Para cadastrar ou retomar novos vínculos, escolha um plano com mais capacidade.",
    en: "You currently have {count} active patient. To add or resume new links, choose a plan with more capacity.",
    es: "Hoy tienes {count} paciente activo. Para registrar o retomar nuevos vínculos, elige un plan con más capacidad.",
    de: "Sie haben derzeit {count} aktiven Patienten. Um neue Links hinzuzufügen oder fortzusetzen, wählen Sie einen Plan mit mehr Kapazität.",
  },
  upgradePlanActiveCountPlural: {
    "pt-BR": "Hoje você tem {count} pacientes ativos. Para cadastrar ou retomar novos vínculos, escolha um plano com mais capacidade.",
    en: "You currently have {count} active patients. To add or resume new links, choose a plan with more capacity.",
    es: "Hoy tienes {count} pacientes activos. Para registrar o retomar nuevos vínculos, elige un plan con más capacidad.",
    de: "Sie haben derzeit {count} aktive Patienten. Um neue Links hinzuzufügen oder fortzusetzen, wählen Sie einen Plan mit mehr Kapazität.",
  },
  choosePaidPlan: {
    "pt-BR": "Escolher plano pago",
    en: "Choose paid plan",
    es: "Elegir plan de pago",
    de: "Wählen Sie einen kostenpflichtigen Plan",
  },
  dontShowAgain: {
    "pt-BR": "Não mostrar novamente",
    en: "Don't show again",
    es: "No mostrar de nuevo",
    de: "Nicht mehr anzeigen",
  },
} as const;
